module.exports = __webpack_public_path__ + "static/media/Chat-unselected.285be757.svg";